import ImagesHelpcentre1Png from '@/public/images/helpcentre/1.png';
import ImagesHelpcentre2Png from '@/public/images/helpcentre/2.png';
import ImagesHelpcentre3Png from '@/public/images/helpcentre/3.png';
import ImagesHelpcentre4Png from '@/public/images/helpcentre/4.png';
import ImagesHelpcentre5Png from '@/public/images/helpcentre/5.png';
import ImagesHelpcentre6Png from '@/public/images/helpcentre/6.png';
import ImagesHelpcentre7Png from '@/public/images/helpcentre/7.png';
import ImagesHelpcentre8Png from '@/public/images/helpcentre/8.png';
import ImagesHelpcentreBasic1Png from '@/public/images/helpcentre/basic1.png';
import ImagesHelpcentreBasic2Png from '@/public/images/helpcentre/basic2.png';
import ImagesHelpcentreBasic3Png from '@/public/images/helpcentre/basic3.png';
import ImagesHelpcentreBasic4Png from '@/public/images/helpcentre/basic4.png';
import ImagesHelpcentreLogoPng from '@/public/images/helpcentre/logo.png';

export {
  ImagesHelpcentre1Png,
  ImagesHelpcentre2Png,
  ImagesHelpcentre3Png,
  ImagesHelpcentre4Png,
  ImagesHelpcentre5Png,
  ImagesHelpcentre6Png,
  ImagesHelpcentre7Png,
  ImagesHelpcentre8Png,
  ImagesHelpcentreBasic1Png,
  ImagesHelpcentreBasic2Png,
  ImagesHelpcentreBasic3Png,
  ImagesHelpcentreBasic4Png,
  ImagesHelpcentreLogoPng,
};
